module.exports = __webpack_public_path__ + "static/media/03auh.246307d9.png";